export const selectUid = state => state.user.uid
export const selectUserProfile = state => state.user.userProfile



// WEBPACK FOOTER //
// ./src/redux/selectors/index.js